import { SUPPORTED_LANGUAGE } from './language.model';

export function getCountryFlag(languageCode: SUPPORTED_LANGUAGE | string): string {
  const splitedLanguageCode = languageCode.split('-');
  const language = SUPPORTED_LANGUAGE[languageCode];

  if (splitedLanguageCode.length > 1) {
    return `flag-${splitedLanguageCode[1].toLowerCase()}`;
  } else {
    return `flag-${language.slice(-2).toLowerCase()}`;
  }
}
